import { KeyValue } from '@/main/models/common';
import { UserGroupTypes, UserGroupActionTypes } from './userGroupTypes';
import { UserGroupFilterRequest } from '@/main/models/request/usergroupRequest';

export function getUsersGroupUser(groupFilter: UserGroupFilterRequest): UserGroupActionTypes {
  return {
    type: UserGroupTypes.GET_USERSGROUP_USER,
    payload: { groupFilter }
  };
}

export function saveUsersGroupUser(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): UserGroupActionTypes {
  return {
    type: UserGroupTypes.SAVE_USERSGROUP_USER,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerUsersGroupUser(): UserGroupActionTypes {
  return {
    type: UserGroupTypes.RESET_REDUCER_USERSGROUP_USER
  };
}
